export const rwColors = {
  main: '#377E7F',
  sub: '#0C4552',
  'dark-blue': '#0F2630',
  white: '#EDF1F2',
  'light-gray': '#CED7DA',
  gray: '#9DA5AB',
  'dark-gray': '#565A5B',
  black: '#040E11',
  link: '#0000EE',
  'black-gray': '#2C3030',
  red: '#BD1C1C',
  green: '#008848',
} as const;
